export const PATENT_DESIGN_STATUS = {
  received: "접수",
  reviewing: "검토 중",
  quoted: "견적 발송",
  paid: "결제 완료",
  preparing: "출원 준비",
  filed: "출원 완료(심사 중)",
  office_action: "의견제출통지",
  allowed: "등록 결정",
  registered: "등록 완료",
  rejected: "거절",
  canceled: "취소",
};

export const PATENT_DESIGN_STATUS_ORDER = [
  "received",
  "reviewing",
  "quoted",
  "paid",
  "preparing",
  "filed",
  "office_action",
  "allowed",
  "registered",
  "rejected",
  "canceled",
];

const AUTO_STATUSES = ["quoted", "paid"];

export const MANUAL_STATUSES = PATENT_DESIGN_STATUS_ORDER.filter(
  (status) => !AUTO_STATUSES.includes(status)
);

export const PAYMENT_BLOCKED_STATUSES = ["registered", "rejected", "canceled"];

export const isPaymentRequestable = (status) => !PAYMENT_BLOCKED_STATUSES.includes(status);

export const DOCUMENT_REQUEST_BLOCKED_STATUSES = ["rejected", "canceled"];

export const isDocumentRequestable = (status) => !DOCUMENT_REQUEST_BLOCKED_STATUSES.includes(status);

export const QUOTE_AUTO_STATUSES = ["received", "reviewing", "quoted"];

export const MAIL_NOTIFY_STATUSES = ["filed", "registered", "rejected"];

export const PATENT_DESIGN_STATUS_STYLE = {
  received: { backgroundColor: "#dbeafe", color: "#1d4ed8" },
  reviewing: { backgroundColor: "#e0f2fe", color: "#0369a1" },
  quoted: { backgroundColor: "#fef3c7", color: "#b45309" },
  paid: { backgroundColor: "#dcfce7", color: "#15803d" },
  preparing: { backgroundColor: "#ede9fe", color: "#6d28d9" },
  filed: { backgroundColor: "#e0e7ff", color: "#4338ca" },
  office_action: { backgroundColor: "#ffedd5", color: "#c2410c" },
  allowed: { backgroundColor: "#ccfbf1", color: "#0f766e" },
  registered: { backgroundColor: "#e2e8f0", color: "#0f172a" },
  rejected: { backgroundColor: "#fee2e2", color: "#b91c1c" },
  canceled: { backgroundColor: "#f1f5f9", color: "#64748b" },
};

export const REQUEST_TYPE = { patent: "특허", design: "디자인", both: "특허+디자인" };
export const REQUEST_TYPE_ORDER = ["patent", "design", "both"];
export const UNASSIGNED_LABEL = "미지정";
export const requestTypeLabel = (type) => REQUEST_TYPE[type] || UNASSIGNED_LABEL;
export const REQUEST_TYPE_FILTER_OPTIONS = [
  ...REQUEST_TYPE_ORDER.map((value) => ({ value, label: REQUEST_TYPE[value] })),
  { value: "unassigned", label: UNASSIGNED_LABEL },
];

export const SERVICE_TYPE = { patent: "특허", design: "디자인" };
export const SERVICE_TYPE_ORDER = ["patent", "design"];

export const DOCUMENT_REQUEST_STATUS = {
  requested: "요청됨",
  submitted: "제출됨",
  closed: "종료",
};

export const DOCUMENT_REQUEST_STATUS_STYLE = {
  requested: { backgroundColor: "#fef3c7", color: "#b45309" },
  submitted: { backgroundColor: "#dcfce7", color: "#15803d" },
  closed: { backgroundColor: "#f1f5f9", color: "#64748b" },
};

export const HISTORY_ACTOR = { user: "고객", admin: "관리자", system: "자동" };

export const SESSION_ERROR_RESULTS = [
  "duplicateLogin",
  "tokenError",
  "tokenExpired",
  "accessDenied",
];

export const NOTICE_MAX_BYTES = 3000;
export const DESCRIPTION_MAX_BYTES = 3000;
export const TITLE_MAX_LENGTH = 100;
export const NUMBER_MAX_LENGTH = 50;
export const MAX_FILE_COUNT = 5;
const MAX_FILE_SIZE = 10 * 1024 * 1024;
const MAX_TOTAL_SIZE = 40 * 1024 * 1024;
const ALLOWED_EXTENSIONS = ["jpg", "jpeg", "png", "pdf", "hwp", "hwpx", "doc", "docx", "ppt", "pptx", "zip"];
export const FILE_ACCEPT = ALLOWED_EXTENSIONS.map((ext) => `.${ext}`).join(",");

export const ERROR_MESSAGE = {
  tooManyFiles: `파일은 최대 ${MAX_FILE_COUNT}개까지 첨부할 수 있습니다.`,
  fileTooLarge: "파일 하나는 10MB 이하여야 합니다.",
  filesTooLarge: "첨부 파일 합계는 40MB 이하여야 합니다.",
  invalidFileType: "첨부할 수 없는 파일 형식입니다. (jpg, png, pdf, hwp, doc, ppt, zip 등)",
  fileRequired: "첨부할 파일을 선택해 주세요.",
  invalidStatus: "변경할 수 없는 단계입니다.",
  invalidRequestStatus: "등록 완료 · 거절 · 취소된 신청에는 결제를 요청할 수 없습니다.",
  invalidRequestType: "유형 값이 올바르지 않습니다.",
  invalidDate: "날짜 형식이 올바르지 않습니다.",
  invalidNumber: `출원번호 · 등록번호는 ${NUMBER_MAX_LENGTH}자 이하로 입력해 주세요.`,
  invalidContent: `안내 내용은 1~${NOTICE_MAX_BYTES}byte로 입력해 주세요.`,
  invalidTitle: `제목은 1~${TITLE_MAX_LENGTH}자로 입력해 주세요.`,
  invalidDescription: `요청 설명은 ${DESCRIPTION_MAX_BYTES}byte 이하로 입력해 주세요.`,
  documentNotDeletable: "고객용 서류만 삭제할 수 있습니다.",
  invalidServiceType: "결제 유형 값이 올바르지 않습니다.",
  notLinkedPayment: "특허·디자인 신청에 연결된 결제만 유형을 바꿀 수 있습니다.",
  invalidDocumentRequestStatus: "이미 종료된 요청입니다. 새로 고침 후 확인해 주세요.",
  serviceTypeRequired: "서비스 유형을 선택해주세요.",
};

const extensionOf = (name = "") => {
  const index = name.lastIndexOf(".");
  return index < 0 ? "" : name.slice(index + 1).toLowerCase();
};

export const validateUploadFiles = (files, maxCount = MAX_FILE_COUNT) => {
  if (files.length > maxCount) return "tooManyFiles";
  if (files.some((file) => !ALLOWED_EXTENSIONS.includes(extensionOf(file.name)))) {
    return "invalidFileType";
  }
  if (files.some((file) => file.size > MAX_FILE_SIZE)) return "fileTooLarge";
  if (files.reduce((sum, file) => sum + file.size, 0) > MAX_TOTAL_SIZE) return "filesTooLarge";
  return null;
};

export const normalizeNewlines = (value = "") => (value || "").replace(/\r\n/g, "\n");

export const utf8ByteLength = (value = "") => {
  let bytes = 0;
  for (const char of value) {
    const code = char.codePointAt(0);
    if (code <= 0x7f) bytes += 1;
    else if (code <= 0x7ff) bytes += 2;
    else if (code <= 0xffff) bytes += 3;
    else bytes += 4;
  }
  return bytes;
};

const pad = (n) => String(n).padStart(2, "0");

const toDate = (value) => {
  if (!value) return null;
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};

export const formatDate = (value) => {
  const date = toDate(value);
  if (!date) return "-";
  return `${date.getFullYear()}.${pad(date.getMonth() + 1)}.${pad(date.getDate())}`;
};

export const formatDateTime = (value) => {
  const date = toDate(value);
  if (!date) return "-";
  return `${formatDate(value)} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
};

export const formatDateOnly = (value) =>
  /^\d{4}-\d{2}-\d{2}/.test(value || "") ? value.slice(0, 10).replace(/-/g, ".") : "-";

export const formatFileSize = (bytes) => {
  const size = Number(bytes) || 0;
  if (size >= 1024 * 1024) return `${(size / 1024 / 1024).toFixed(1)}MB`;
  if (size >= 1024) return `${Math.round(size / 1024)}KB`;
  return `${size}B`;
};

export const formatPrice = (value) => {
  if (value === null || value === undefined || value === "") return "-";
  const n = Number(value);
  return Number.isNaN(n) ? "-" : n.toLocaleString("ko-KR");
};
